import { GetTokenWithExpiry } from '../utilities/tokenSetting'
import jwt_decode from 'jwt-decode'

export const userId = () => {
  var decoded
  if (GetTokenWithExpiry('token')) {
    decoded = jwt_decode(GetTokenWithExpiry('token'))
    return decoded.userId
  } else {
    return 0
  }
}
